import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-message-status',
  template: `
    <div class="status status--checked" *ngIf="status === 'Approved'"><ui-icon nameIcon="check"></ui-icon> Доставлено</div>
    <div class="status status--moderation" *ngIf="status === 'Moderation'">Модерация</div>
    <div class="status status--return" *ngIf="status === 'Declined'">Отклонено</div>
  `,
  styleUrls: ['./chat-message-status.component.scss']
})
export class ChatMessageStatusComponent implements OnInit {
  @Input() status: 'Approved' | 'Moderation' | 'Declined';
  constructor() { }
  ngOnInit(): void {
  }

}
